var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSafetyGuide1Icon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8368_3545)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.1085 14.9999L11.4419 3.33319C11.2965 3.0767 11.0857 2.86335 10.831 2.71492C10.5762 2.56649 10.2867 2.48828 9.99185 2.48828C9.69703 2.48828 9.40748 2.56649 9.15275 2.71492C8.89802 2.86335 8.68722 3.0767 8.54185 3.33319L1.87519 14.9999C1.72825 15.2543 1.65121 15.5431 1.65186 15.837C1.65251 16.1308 1.73083 16.4192 1.87889 16.673C2.02695 16.9269 2.23948 17.137 2.49493 17.2822C2.75039 17.4274 3.03969 17.5025 3.33352 17.4999H16.6669C16.9593 17.4996 17.2465 17.4223 17.4996 17.2759C17.7527 17.1295 17.9629 16.9191 18.1089 16.6658C18.255 16.4125 18.3319 16.1252 18.3318 15.8328C18.3317 15.5404 18.2547 15.2531 18.1085 14.9999Z",
    stroke: "#D08700",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 7.5V10.8333",
    stroke: "#D08700",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 14.1667H10.0083",
    stroke: "#D08700",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8368_3545"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSafetyGuide1Icon);
export default __webpack_public_path__ + "static/media/safety_guide_1_icon.80722a28796174d4d94c8558db98cfcb.svg";
export { ForwardRef as ReactComponent };